import { render } from "./ForecastDetail.vue?vue&type=template&id=552a9e3c&scoped=true"
import script from "./ForecastDetail.vue?vue&type=script&lang=js"
export * from "./ForecastDetail.vue?vue&type=script&lang=js"

import "./ForecastDetail.vue?vue&type=style&index=0&id=552a9e3c&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-552a9e3c"]])

export default __exports__